<template>
  <v-container id="calculo-extraordinario" fluid>
    <v-row>
      <v-col cols="12" md="4">
        <v-autocomplete v-model="staff_id" color="gold" :items="staff" item-value="id" label="Staff" :item-text="item =>` ${item.fullName}`">
          <template v-slot:item="{ attrs, item, on }">
            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
              <v-list-item-content>
                <v-list-item-title v-text="item.fullName" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="4">
        <v-select v-model="moneda_id" :items="monedas" label="Moneda" item-value="id" item-text="descripcion" />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field v-model="monto" color="gold" type="number" step="0.01" :prefix="simboloMoneda" label="Total a pagar" :disabled="bloquear" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'StaffTab',
    props: {
      toggleReset: {
        type: Boolean,
        required: true,
        default: false,
      },
      monedas: {
        type: Array,
        default: function () {
          return []
        },
        required: false,
      },
      bloquear: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        staff: [],
        moneda_id: 1,
        monto: 0,
        staff_id: 0,
        typingTimer: {},
      }
    },
    computed: {
      simboloMoneda () {
        return (this.monedas.length !== 0) ? this.monedas.find(e => e.id === this.moneda_id).simbolo : '$'
      },
    },
    watch: {
      toggleReset () {
        this.monto = 0
        this.staff_id = 0
      },
      moneda_id () {
        this.enviarPadre()
      },
      monto (val) {
        if (val !== 0) {
          clearTimeout(this.typingTimer)
          this.typingTimer = setTimeout(() => this.comprobarMonto(), 1500)
        }
      },
      staff_id () {
        this.enviarPadre()
      },
    },
    created () {
      this.getStaff()
    },
    methods: {
      comprobarMonto () {
        if (this.staff_id === 0) {
          this.$store.commit('toast/show', { tipo: 'info', messages: ['Debe seleccionar una persona (staff).'] })
          this.monto = 0
        } else {
          this.acomodarMonto()
        }
      },
      getStaff () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/staff_get' }).then(response => { this.staff = response })
      },
      acomodarMonto () {
        const aux = parseFloat(this.monto)
        if (aux < 0) {
          this.monto = (aux * -1)
          this.$store.commit('toast/show', { tipo: 'info', messages: ['El monto debe ser una valor positivo.'] })
        }
        this.enviarPadre()
      },
      enviarPadre () {
        const datos = {
          totalAPagar: this.monto,
          monedaId: this.moneda_id,
          objetoPago: this.staff_id,
          caso: 'Staff',
        }
        this.$emit('montoGenerado', datos)
      },
    },
  }
</script>
